RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.SocialChannel = RivalIQ.views.LayoutView.extend({
        template: '#adminCompanySocialChannelTemplate',
        className: 'col-md-4',

        templateHelpers: function () {
            const me = this;

            return {
                details: me.model.getDetails()
            };
        },

        regions: {
            primaryHandle: '.x-primary-handle'
        },

        ui: {
            domainSearchLink: '.x-domain-search',
            nameSearchLink: '.x-name-search',
            channelDiscoveryBtn: '.x-channel-discovery',
            handleInput: '.x-handle-input',
            addHandleBtn: '.x-add-handle',
            findFlagBtn: '.x-find-flag',
            socialHandlesBtn: '.x-social-handles'
        },

        events: {
            'click @ui.domainSearchLink': 'onDomainSearchClick',
            'click @ui.nameSearchLink': 'onNameSearchClick',
            'click @ui.channelDiscoveryBtn': 'onChannelDiscoveryClick',
            'keypress @ui.handleInput': 'onHandleKeypress',
            'click @ui.addHandleBtn': 'addHandle',
            'click @ui.findFlagBtn': 'onFindFlagClick',
            'click @ui.socialHandlesBtn': 'onSocialHandlesBtnClick'
        },

        modelEvents: {
            'change:finderFlag': 'render'
        },

        collectionEvents: {
            'change:is_primary': 'render',
            'add': 'render',
            'remove': 'render'
        },

        onRender: function () {
            const me = this;

            const model = me.collection.getPrimary();
            if (model) {
                me.primaryHandle.show(new views.SocialHandle({
                    template: '#adminCompanyPrimarySocialHandleTemplate',
                    tagName: 'div',
                    className: 'col-md-12',
                    model: model
                }));
            } else {
                me.primaryHandle.show(new views.EmptySocialHandles({
                    tagName: 'div',
                    className: 'col-md-12'
                }));
            }
        },

        initialize: function (options) {
            const me = this;
            me.companyModel = options.companyModel;

            const handlesCollection = me.model.get('handles');
            me.listenTo(handlesCollection, 'duplicate', me.onDuplicate);
        },

        onDomainSearchClick: function (e) {
            const me = this;
            const target = $(e.currentTarget);
            let domain = me.options.companyModel.get('source');
            const parts = domain.split('.');

            if (parts.length === 2) {
                domain = parts[0];
            } else if (parts.length === 3 || parts.length === 4) {
                domain = parts[1];
            }

            target.attr('href', target.data('url') + encodeURIComponent(domain));
        },

        onNameSearchClick: function (e) {
            const me = this;
            const target = $(e.currentTarget);
            const name = me.options.companyModel.get('name');
            target.attr('href', target.data('url') + encodeURIComponent(name));
        },

        onChannelDiscoveryClick: function () {
            const me = this;

            App.handleDiscoveryModal.show(new views.HandlePicker({
                model: me.model.get('handles'),
                collection: me.model.get('discoveries')
            }));
        },

        onHandleKeypress: function (e) {
            const me = this;

            if (e.which === 13) {
                e.preventDefault();
                me.addHandle();
            }
        },

        onFindFlagClick: function () {
            const me = this;
            me.model.set({
                finderFlag: !me.model.get('finderFlag')
            });
            me.render();
        },

        onSocialHandlesBtnClick: function () {
            const me = this;

            App.socialHandlesModal.show(new views.SocialHandles({
                collection: me.model.get('handles')
            }));
        },

        addHandle: function () {
            const me = this;
            const handle = $.trim(me.ui.handleInput.val());

            if (handle.length) {
                me.ui.addHandleBtn.button('loading');
                const handleModel = me.model.getHandle(handle);

                const deferred = RivalIQ.utils.async.callbackToDeferred(function (error) {
                    me.requestRenderedFrame(function () {
                        me.ui.addHandleBtn.button('reset');

                        if (error) {
                            return RivalIQ.execute('alert:error', error);
                        } else {
                            me.collection.push(handleModel);
                            handleModel.set({
                                is_primary: true
                            });
                            me.ui.handleInput.val('');
                        }
                    });
                });

                handleModel.fetch({
                    finderPicked: false
                }).done(deferred.resolve).fail(deferred.reject);
            }
        },

        onDuplicate: function () {
            RivalIQ.execute('alert:warning', 'Handle could not be added because it is a duplicate of an existing handle');
        }
    });
});
